export const isImage = (attachment) => {
	const type = attachment?.name.split('.').pop().toLowerCase()
	return type === 'png' || type === 'jpeg' || type === 'jpg'
}

export const isAudio = (attachment) => {
  const type = attachment?.name.toLowerCase().split('.').pop();
  return ['mp3', 'wav', 'ogg', 'aac', 'flac'].includes(type);
};


export const isPDF = (attachment) => {
  const type = attachment?.name.toLowerCase().split('.').pop();
  return type === 'pdf'
};

export const getAttachmentLabel = (attachment) => {
  if (!attachment?.name) return 'Файл';
  const ext = attachment.name.split('.').pop().toLowerCase();
  if (['png', 'jpg', 'jpeg', 'gif', 'webp', 'bmp', 'svg'].includes(ext)) return 'Изображение';
  if (['mp3', 'wav', 'ogg', 'aac', 'flac'].includes(ext)) return 'Аудиозапись';
  if (['mp4', 'mov', 'avi', 'mkv', 'webm'].includes(ext)) return 'Видео';
  if (['pdf', 'doc', 'docx', 'txt', 'xls', 'xlsx', 'ppt', 'pptx', 'csv', 'xml', 'html', 'zip', 'rar', '7z'].includes(ext)) return 'Документ';
  return 'Файл';
};